(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './ktor-ktor-io.js', './kotlinx-atomicfu.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-io.js'), require('./kotlinx-atomicfu.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-utils'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-utils'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-utils'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-utils'.");
    }
    if (typeof this['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-utils'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-utils'.");
    }
    if (typeof this['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-utils'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'ktor-ktor-utils'.");
    }
    root['ktor-ktor-utils'] = factory(typeof this['ktor-ktor-utils'] === 'undefined' ? {} : this['ktor-ktor-utils'], this['kotlin-kotlin-stdlib'], this['kotlinx-coroutines-core'], this['ktor-ktor-io'], this['kotlinx-atomicfu']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_io, kotlin_org_jetbrains_kotlinx_atomicfu) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var charSequenceLength = kotlin_kotlin.$_$.v9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var protoOf = kotlin_kotlin.$_$.hb;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var getStringHashCode = kotlin_kotlin.$_$.fa;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var VOID = kotlin_kotlin.$_$.g;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i1;
  var ByteChannel = kotlin_io_ktor_ktor_io.$_$.f1;
  var to = kotlin_kotlin.$_$.qf;
  var CoroutineImpl = kotlin_kotlin.$_$.j9;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y;
  var isInterface = kotlin_kotlin.$_$.va;
  var Long = kotlin_kotlin.$_$.je;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.v8;
  var addSuppressedInternal = kotlin_io_ktor_ktor_io.$_$.v;
  var close = kotlin_io_ktor_ktor_io.$_$.k1;
  var initMetadataForLambda = kotlin_kotlin.$_$.la;
  var get_ByteArrayPool = kotlin_io_ktor_ktor_io.$_$.e1;
  var readAvailable = kotlin_io_ktor_ktor_io.$_$.c;
  var async = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c1;
  var listOf = kotlin_kotlin.$_$.q7;
  var awaitAll = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b;
  var readBytes = kotlin_io_ktor_ktor_io.$_$.x;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ja;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var equals = kotlin_kotlin.$_$.z9;
  var hashCode = kotlin_kotlin.$_$.ga;
  var KtMutableMap = kotlin_kotlin.$_$.q5;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var Entry = kotlin_kotlin.$_$.n5;
  var toString = kotlin_kotlin.$_$.pf;
  var charArray = kotlin_kotlin.$_$.t9;
  var charSequenceGet = kotlin_kotlin.$_$.u9;
  var toString_0 = kotlin_kotlin.$_$.t2;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
  var AbstractCoroutineContextElement = kotlin_kotlin.$_$.y8;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i;
  var Element = kotlin_kotlin.$_$.h9;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var KtSet = kotlin_kotlin.$_$.s5;
  var toString_1 = kotlin_kotlin.$_$.lb;
  var KtMutableSet = kotlin_kotlin.$_$.r5;
  var Enum = kotlin_kotlin.$_$.ee;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var firstOrNull = kotlin_kotlin.$_$.x6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.l;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.t;
  var KtMap = kotlin_kotlin.$_$.o5;
  var emptyMap = kotlin_kotlin.$_$.t6;
  var getBooleanHashCode = kotlin_kotlin.$_$.ca;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.c1;
  var get_lastIndex = kotlin_kotlin.$_$.tc;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.m2;
  var Char__plus_impl_qi7pgj = kotlin_kotlin.$_$.q2;
  var equals_0 = kotlin_kotlin.$_$.hc;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ia;
  var Comparable = kotlin_kotlin.$_$.be;
  var isSuspendFunction = kotlin_kotlin.$_$.ya;
  var KtMutableList = kotlin_kotlin.$_$.p5;
  var objectCreate = kotlin_kotlin.$_$.gb;
  var ArrayList = kotlin_kotlin.$_$.f5;
  var emptyList = kotlin_kotlin.$_$.s6;
  var get_lastIndex_0 = kotlin_kotlin.$_$.l7;
  var last = kotlin_kotlin.$_$.o7;
  var mutableListOf = kotlin_kotlin.$_$.t7;
  var extendThrowable = kotlin_kotlin.$_$.aa;
  var captureStack = kotlin_kotlin.$_$.r9;
  var recoverStackTrace = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s;
  var Companion_instance = kotlin_kotlin.$_$.y4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.u2;
  var createFailure = kotlin_kotlin.$_$.df;
  var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.v2;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.w2;
  var Continuation = kotlin_kotlin.$_$.d9;
  var fillArrayVal = kotlin_kotlin.$_$.ba;
  var intercepted = kotlin_kotlin.$_$.x8;
  var toList = kotlin_kotlin.$_$.l8;
  var isNaN_0 = kotlin_kotlin.$_$.if;
  var numberToLong = kotlin_kotlin.$_$.fb;
  var IllegalStateException = kotlin_kotlin.$_$.ie;
  var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.t1;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.y2;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.lf;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(AttributeKey, 'AttributeKey');
  function get(key) {
    var tmp0_elvis_lhs = this.q34(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('No instance for key ' + key.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  initMetadataForInterface(Attributes, 'Attributes');
  initMetadataForLambda(copyToBoth$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(split$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(split$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(split$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($toByteArrayCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(CaseInsensitiveMap, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap]);
  initMetadataForClass(Entry_0, 'Entry', VOID, VOID, [Entry]);
  initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, Element]);
  initMetadataForClass(DelegatingMutableSet$iterator$1);
  initMetadataForClass(DelegatingMutableSet, 'DelegatingMutableSet', VOID, VOID, [KtMutableSet]);
  initMetadataForClass(Platform, 'Platform', VOID, Enum);
  initMetadataForObject(PlatformUtils, 'PlatformUtils');
  function get_0(name) {
    var tmp0_safe_receiver = this.l38(name);
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  function forEach(body) {
    var tmp0_iterator = this.n38().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.util.StringValues.forEach.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.u();
      // Inline function 'kotlin.collections.component2' call
      var v = element.v();
      body(k, v);
    }
    return Unit_instance;
  }
  initMetadataForInterface(StringValues, 'StringValues');
  initMetadataForClass(StringValuesBuilderImpl, 'StringValuesBuilderImpl', StringValuesBuilderImpl);
  initMetadataForClass(StringValuesImpl, 'StringValuesImpl', StringValuesImpl, VOID, [StringValues]);
  initMetadataForClass(CaseInsensitiveString, 'CaseInsensitiveString');
  initMetadataForClass(CopyOnWriteHashMap, 'CopyOnWriteHashMap', CopyOnWriteHashMap);
  initMetadataForCompanion(Companion);
  initMetadataForClass(GMTDate, 'GMTDate', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(WeekDay, 'WeekDay', VOID, Enum);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(Month, 'Month', VOID, Enum);
  initMetadataForClass(Symbol, 'Symbol');
  initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode');
  initMetadataForClass(Removed, 'Removed');
  initMetadataForClass(OpDescriptor, 'OpDescriptor');
  initMetadataForCoroutine($proceedLoopCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(PipelineContext, 'PipelineContext', VOID, VOID, [CoroutineScope], [1, 0]);
  initMetadataForClass(DebugPipelineContext, 'DebugPipelineContext', VOID, PipelineContext, VOID, [1, 0]);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(PhaseContent, 'PhaseContent');
  initMetadataForClass(Pipeline, 'Pipeline', VOID, VOID, VOID, [2]);
  initMetadataForClass(PipelinePhase, 'PipelinePhase');
  initMetadataForClass(InvalidPhaseException, 'InvalidPhaseException', VOID, Error);
  initMetadataForClass(PipelinePhaseRelation, 'PipelinePhaseRelation');
  initMetadataForClass(After, 'After', VOID, PipelinePhaseRelation);
  initMetadataForClass(Before, 'Before', VOID, PipelinePhaseRelation);
  initMetadataForObject(Last, 'Last', VOID, PipelinePhaseRelation);
  initMetadataForClass(SuspendFunctionGun$continuation$1, VOID, VOID, VOID, [Continuation]);
  initMetadataForClass(SuspendFunctionGun, 'SuspendFunctionGun', VOID, PipelineContext, VOID, [0, 1]);
  initMetadataForClass(TypeInfo, 'TypeInfo');
  initMetadataForClass(AttributesJs, 'AttributesJs', AttributesJs, VOID, [Attributes]);
  initMetadataForClass(InvalidTimestampException, 'InvalidTimestampException', VOID, IllegalStateException);
  initMetadataForClass(KtorSimpleLogger$1);
  initMetadataForClass(LogLevel, 'LogLevel', VOID, Enum);
  initMetadataForObject(JsType, 'JsType');
  //endregion
  function AttributeKey(name) {
    this.o34_1 = name;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.o34_1;
    if (charSequenceLength(this_0) === 0) {
      throw IllegalStateException_init_$Create$("Name can't be blank");
    }
  }
  protoOf(AttributeKey).toString = function () {
    return 'AttributeKey: ' + this.o34_1;
  };
  protoOf(AttributeKey).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AttributeKey))
      THROW_CCE();
    if (!(this.o34_1 === other.o34_1))
      return false;
    return true;
  };
  protoOf(AttributeKey).hashCode = function () {
    return getStringHashCode(this.o34_1);
  };
  function Attributes() {
  }
  function putAll(_this__u8e3s4, other) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = other.v34().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.util.putAll.<anonymous>' call
      _this__u8e3s4.s34(element instanceof AttributeKey ? element : THROW_CCE(), other.p34(element));
    }
  }
  function toByteArray(_this__u8e3s4, $completion) {
    var tmp = new $toByteArrayCOROUTINE$0(_this__u8e3s4, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function copyToBoth(_this__u8e3s4, first, second) {
    var tmp = GlobalScope_instance;
    var tmp_0 = Dispatchers_getInstance().ov_1;
    var tmp_1 = launch(tmp, tmp_0, VOID, copyToBoth$slambda_0(_this__u8e3s4, first, second, null));
    tmp_1.rk(copyToBoth$lambda(first, second));
  }
  function split(_this__u8e3s4, coroutineScope) {
    var first = ByteChannel(true);
    var second = ByteChannel(true);
    var tmp = launch(coroutineScope, VOID, VOID, split$slambda_0(_this__u8e3s4, first, second, null));
    tmp.rk(split$lambda(first, second));
    return to(first, second);
  }
  function copyToBoth$slambda($this_copyToBoth, $first, $second, resultContinuation) {
    this.n35_1 = $this_copyToBoth;
    this.o35_1 = $first;
    this.p35_1 = $second;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(copyToBoth$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(copyToBoth$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(copyToBoth$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 15;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.k8_1 = 14;
            this.k8_1 = 13;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            if (!(!this.n35_1.o2q() && (!this.o35_1.d2w() || !this.p35_1.d2w()))) {
              this.j8_1 = 12;
              continue $sm;
            }

            this.j8_1 = 3;
            suspendResult = this.n35_1.h2w(new Long(4096, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.s35_1 = suspendResult;
            this.t35_1 = false;
            this.u35_1 = Unit_instance;
            this.j8_1 = 4;
            continue $sm;
          case 4:
            this.k8_1 = 10;
            this.k8_1 = 9;
            var tmp_0 = this;
            tmp_0.v35_1 = this.s35_1;
            this.k8_1 = 7;
            this.j8_1 = 5;
            suspendResult = this.o35_1.e2w(this.v35_1.i20(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.j8_1 = 6;
            suspendResult = this.p35_1.e2w(this.v35_1.i20(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_1 = this;
            tmp_1.w35_1 = Unit_instance;
            this.k8_1 = 9;
            this.j8_1 = 8;
            continue $sm;
          case 7:
            this.k8_1 = 9;
            var tmp_2 = this.m8_1;
            if (tmp_2 instanceof Error) {
              var cause = this.m8_1;
              var tmp_3 = this;
              this.n35_1.kq(cause);
              this.o35_1.v11(cause);
              tmp_3.w35_1 = this.p35_1.v11(cause);
              this.j8_1 = 8;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 8:
            this.k8_1 = 9;
            this.u35_1 = this.w35_1;
            this.j8_1 = 11;
            continue $sm;
          case 9:
            this.k8_1 = 10;
            var tmp_4 = this.m8_1;
            if (tmp_4 instanceof Error) {
              var first = this.m8_1;
              var tmp_5 = this;
              try {
                this.t35_1 = true;
                this.s35_1.j2z();
              } catch ($p) {
                if ($p instanceof Error) {
                  var second = $p;
                  addSuppressedInternal(first, second);
                } else {
                  throw $p;
                }
              }
              throw first;
            } else {
              throw this.m8_1;
            }

          case 10:
            this.k8_1 = 13;
            var t = this.m8_1;
            if (!this.t35_1) {
              this.s35_1.j2z();
            }

            throw t;
          case 11:
            this.u35_1;
            this.k8_1 = 13;
            if (!this.t35_1) {
              this.s35_1.j2z();
            }

            this.j8_1 = 2;
            continue $sm;
          case 12:
            var tmp_6 = this;
            var tmp0_safe_receiver = this.n35_1.y2o();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            tmp_6.r35_1 = Unit_instance;
            this.k8_1 = 15;
            this.j8_1 = 16;
            continue $sm;
          case 13:
            this.k8_1 = 14;
            var tmp_7 = this.m8_1;
            if (tmp_7 instanceof Error) {
              var cause_0 = this.m8_1;
              var tmp_8 = this;
              this.o35_1.v11(cause_0);
              this.p35_1.v11(cause_0);
              tmp_8.r35_1 = Unit_instance;
              this.k8_1 = 15;
              this.j8_1 = 16;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 14:
            this.k8_1 = 15;
            var t_0 = this.m8_1;
            close(this.o35_1);
            close(this.p35_1);
            throw t_0;
          case 15:
            throw this.m8_1;
          case 16:
            this.k8_1 = 15;
            close(this.o35_1);
            close(this.p35_1);
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 15) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(copyToBoth$slambda).m17 = function ($this$launch, completion) {
    var i = new copyToBoth$slambda(this.n35_1, this.o35_1, this.p35_1, completion);
    i.q35_1 = $this$launch;
    return i;
  };
  function copyToBoth$slambda_0($this_copyToBoth, $first, $second, resultContinuation) {
    var i = new copyToBoth$slambda($this_copyToBoth, $first, $second, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function copyToBoth$lambda($first, $second) {
    return function (it) {
      if (it == null)
        return Unit_instance;
      $first.v11(it);
      $second.v11(it);
      return Unit_instance;
    };
  }
  function split$slambda$slambda($first, $buffer, $read, resultContinuation) {
    this.f36_1 = $first;
    this.g36_1 = $buffer;
    this.h36_1 = $read;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(split$slambda$slambda).l17 = function ($this$async, $completion) {
    var tmp = this.m17($this$async, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(split$slambda$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(split$slambda$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.f36_1.g2w(this.g36_1, 0, this.h36_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(split$slambda$slambda).m17 = function ($this$async, completion) {
    var i = new split$slambda$slambda(this.f36_1, this.g36_1, this.h36_1, completion);
    i.i36_1 = $this$async;
    return i;
  };
  function split$slambda$slambda_0($first, $buffer, $read, resultContinuation) {
    var i = new split$slambda$slambda($first, $buffer, $read, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.l17($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function split$slambda$slambda_1($second, $buffer, $read, resultContinuation) {
    this.r36_1 = $second;
    this.s36_1 = $buffer;
    this.t36_1 = $read;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(split$slambda$slambda_1).l17 = function ($this$async, $completion) {
    var tmp = this.m17($this$async, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(split$slambda$slambda_1).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(split$slambda$slambda_1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.r36_1.g2w(this.s36_1, 0, this.t36_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(split$slambda$slambda_1).m17 = function ($this$async, completion) {
    var i = new split$slambda$slambda_1(this.r36_1, this.s36_1, this.t36_1, completion);
    i.u36_1 = $this$async;
    return i;
  };
  function split$slambda$slambda_2($second, $buffer, $read, resultContinuation) {
    var i = new split$slambda$slambda_1($second, $buffer, $read, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.l17($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function split$slambda($this_split, $first, $second, resultContinuation) {
    this.d37_1 = $this_split;
    this.e37_1 = $first;
    this.f37_1 = $second;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(split$slambda).l17 = function ($this$launch, $completion) {
    var tmp = this.m17($this$launch, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  };
  protoOf(split$slambda).m9 = function (p1, $completion) {
    return this.l17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(split$slambda).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 8;
            this.h37_1 = get_ByteArrayPool().h2z();
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.k8_1 = 7;
            this.k8_1 = 6;
            this.j8_1 = 2;
            continue $sm;
          case 2:
            if (!!this.d37_1.o2q()) {
              this.j8_1 = 5;
              continue $sm;
            }

            this.j8_1 = 3;
            suspendResult = readAvailable(this.d37_1, this.h37_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.j37_1 = suspendResult;
            this.j8_1 = 4;
            var tmp_0 = async(this.g37_1, VOID, VOID, split$slambda$slambda_0(this.e37_1, this.h37_1, this.j37_1, null));
            suspendResult = awaitAll(listOf([tmp_0, async(this.g37_1, VOID, VOID, split$slambda$slambda_2(this.f37_1, this.h37_1, this.j37_1, null))]), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.j8_1 = 2;
            continue $sm;
          case 5:
            var tmp_1 = this;
            var tmp0_safe_receiver = this.d37_1.y2o();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            tmp_1.i37_1 = Unit_instance;
            this.k8_1 = 8;
            this.j8_1 = 9;
            continue $sm;
          case 6:
            this.k8_1 = 7;
            var tmp_2 = this.m8_1;
            if (tmp_2 instanceof Error) {
              var cause = this.m8_1;
              var tmp_3 = this;
              this.d37_1.kq(cause);
              this.e37_1.kq(cause);
              this.f37_1.kq(cause);
              tmp_3.i37_1 = Unit_instance;
              this.k8_1 = 8;
              this.j8_1 = 9;
              continue $sm;
            } else {
              throw this.m8_1;
            }

          case 7:
            this.k8_1 = 8;
            var t = this.m8_1;
            get_ByteArrayPool().i2z(this.h37_1);
            close(this.e37_1);
            close(this.f37_1);
            throw t;
          case 8:
            throw this.m8_1;
          case 9:
            this.k8_1 = 8;
            get_ByteArrayPool().i2z(this.h37_1);
            close(this.e37_1);
            close(this.f37_1);
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 8) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  protoOf(split$slambda).m17 = function ($this$launch, completion) {
    var i = new split$slambda(this.d37_1, this.e37_1, this.f37_1, completion);
    i.g37_1 = $this$launch;
    return i;
  };
  function split$slambda_0($this_split, $first, $second, resultContinuation) {
    var i = new split$slambda($this_split, $first, $second, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.l17($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function split$lambda($first, $second) {
    return function (it) {
      if (it == null)
        return Unit_instance;
      $first.kq(it);
      $second.kq(it);
      return Unit_instance;
    };
  }
  function $toByteArrayCOROUTINE$0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e35_1 = _this__u8e3s4;
  }
  protoOf($toByteArrayCOROUTINE$0).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 2;
            this.j8_1 = 1;
            suspendResult = this.e35_1.i2w(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return readBytes(ARGUMENT);
          case 2:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 2) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj($this$$receiver) {
    return $this$$receiver.k37_1;
  }
  function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0($this$$receiver) {
    return caseInsensitive($this$$receiver);
  }
  function CaseInsensitiveMap$_get_entries_$lambda_r32w19($this$$receiver) {
    return new Entry_0($this$$receiver.u().k37_1, $this$$receiver.v());
  }
  function CaseInsensitiveMap$_get_entries_$lambda_r32w19_0($this$$receiver) {
    return new Entry_0(caseInsensitive($this$$receiver.u()), $this$$receiver.v());
  }
  function CaseInsensitiveMap() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.m37_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(CaseInsensitiveMap).j = function () {
    return this.m37_1.j();
  };
  protoOf(CaseInsensitiveMap).v2i = function (key) {
    return this.m37_1.w1(new CaseInsensitiveString(key));
  };
  protoOf(CaseInsensitiveMap).w1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.v2i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).w2i = function (key) {
    return this.m37_1.y1(caseInsensitive(key));
  };
  protoOf(CaseInsensitiveMap).y1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.w2i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).o = function () {
    return this.m37_1.o();
  };
  protoOf(CaseInsensitiveMap).s1 = function () {
    this.m37_1.s1();
  };
  protoOf(CaseInsensitiveMap).n37 = function (key, value) {
    return this.m37_1.b2(caseInsensitive(key), value);
  };
  protoOf(CaseInsensitiveMap).b2 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.n37(tmp, !(value == null) ? value : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).o37 = function (from) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = from.t().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.util.CaseInsensitiveMap.putAll.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.u();
      // Inline function 'kotlin.collections.component2' call
      var value = element.v();
      this.n37(key, value);
    }
  };
  protoOf(CaseInsensitiveMap).d2 = function (from) {
    return this.o37(from);
  };
  protoOf(CaseInsensitiveMap).r2j = function (key) {
    return this.m37_1.c2(caseInsensitive(key));
  };
  protoOf(CaseInsensitiveMap).c2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.r2j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).z1 = function () {
    var tmp = this.m37_1.z1();
    var tmp_0 = CaseInsensitiveMap$_get_keys_$lambda_ptzlqj;
    return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0);
  };
  protoOf(CaseInsensitiveMap).t = function () {
    var tmp = this.m37_1.t();
    var tmp_0 = CaseInsensitiveMap$_get_entries_$lambda_r32w19;
    return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_entries_$lambda_r32w19_0);
  };
  protoOf(CaseInsensitiveMap).a2 = function () {
    return this.m37_1.a2();
  };
  protoOf(CaseInsensitiveMap).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(other instanceof CaseInsensitiveMap);
    }
    if (tmp)
      return false;
    return equals(other.m37_1, this.m37_1);
  };
  protoOf(CaseInsensitiveMap).hashCode = function () {
    return hashCode(this.m37_1);
  };
  function Entry_0(key, value) {
    this.p37_1 = key;
    this.q37_1 = value;
  }
  protoOf(Entry_0).u = function () {
    return this.p37_1;
  };
  protoOf(Entry_0).v = function () {
    return this.q37_1;
  };
  protoOf(Entry_0).hashCode = function () {
    return (527 + hashCode(ensureNotNull(this.p37_1)) | 0) + hashCode(ensureNotNull(this.q37_1)) | 0;
  };
  protoOf(Entry_0).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(!(other == null) ? isInterface(other, Entry) : false);
    }
    if (tmp)
      return false;
    return equals(other.u(), this.p37_1) && equals(other.v(), this.q37_1);
  };
  protoOf(Entry_0).toString = function () {
    return toString(this.p37_1) + '=' + toString(this.q37_1);
  };
  function toCharArray(_this__u8e3s4) {
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.length;
    var tmp_1 = charArray(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = charSequenceGet(_this__u8e3s4, tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function isLowerCase(_this__u8e3s4) {
    // Inline function 'kotlin.text.lowercaseChar' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = toString_0(_this__u8e3s4).toLowerCase();
    return charSequenceGet(tmp$ret$2, 0) === _this__u8e3s4;
  }
  function caseInsensitiveMap() {
    return new CaseInsensitiveMap();
  }
  function SilentSupervisor(parent) {
    parent = parent === VOID ? null : parent;
    var tmp = SupervisorJob(parent);
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    var tmp$ret$0 = new _no_name_provided__qut3iv();
    return tmp.le(tmp$ret$0);
  }
  function _no_name_provided__qut3iv() {
    AbstractCoroutineContextElement.call(this, Key_instance);
  }
  protoOf(_no_name_provided__qut3iv).wr = function (context, exception) {
    // Inline function 'io.ktor.util.SilentSupervisor.<anonymous>' call
    return Unit_instance;
  };
  function DelegatingMutableSet$iterator$1(this$0) {
    this.t37_1 = this$0;
    this.s37_1 = this$0.u37_1.g();
  }
  protoOf(DelegatingMutableSet$iterator$1).h = function () {
    return this.s37_1.h();
  };
  protoOf(DelegatingMutableSet$iterator$1).i = function () {
    return this.t37_1.v37_1(this.s37_1.i());
  };
  protoOf(DelegatingMutableSet$iterator$1).w3 = function () {
    return this.s37_1.w3();
  };
  function DelegatingMutableSet(delegate, convertTo, convert) {
    this.u37_1 = delegate;
    this.v37_1 = convertTo;
    this.w37_1 = convert;
    this.x37_1 = this.u37_1.j();
  }
  protoOf(DelegatingMutableSet).y37 = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
    var tmp0_iterator = _this__u8e3s4.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'io.ktor.util.DelegatingMutableSet.convert.<anonymous>' call
      var tmp$ret$0 = this.w37_1(item);
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  protoOf(DelegatingMutableSet).z37 = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
    var tmp0_iterator = _this__u8e3s4.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'io.ktor.util.DelegatingMutableSet.convertTo.<anonymous>' call
      var tmp$ret$0 = this.v37_1(item);
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  protoOf(DelegatingMutableSet).j = function () {
    return this.x37_1;
  };
  protoOf(DelegatingMutableSet).a38 = function (element) {
    return this.u37_1.e(this.w37_1(element));
  };
  protoOf(DelegatingMutableSet).e = function (element) {
    return this.a38((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(DelegatingMutableSet).b38 = function (elements) {
    return this.u37_1.n(this.y37(elements));
  };
  protoOf(DelegatingMutableSet).n = function (elements) {
    return this.b38(elements);
  };
  protoOf(DelegatingMutableSet).s1 = function () {
    this.u37_1.s1();
  };
  protoOf(DelegatingMutableSet).c38 = function (element) {
    return this.u37_1.r(this.w37_1(element));
  };
  protoOf(DelegatingMutableSet).r = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.c38((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(DelegatingMutableSet).d38 = function (elements) {
    return this.u37_1.r1(this.y37(elements));
  };
  protoOf(DelegatingMutableSet).r1 = function (elements) {
    return this.d38(elements);
  };
  protoOf(DelegatingMutableSet).o = function () {
    return this.u37_1.o();
  };
  protoOf(DelegatingMutableSet).g = function () {
    return new DelegatingMutableSet$iterator$1(this);
  };
  protoOf(DelegatingMutableSet).hashCode = function () {
    return hashCode(this.u37_1);
  };
  protoOf(DelegatingMutableSet).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(!(other == null) ? isInterface(other, KtSet) : false);
    }
    if (tmp)
      return false;
    var elements = this.z37(this.u37_1);
    var tmp_0;
    if (other.r1(elements)) {
      // Inline function 'kotlin.collections.containsAll' call
      tmp_0 = elements.r1(other);
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  };
  protoOf(DelegatingMutableSet).toString = function () {
    return toString_1(this.z37(this.u37_1));
  };
  var Platform_Jvm_instance;
  var Platform_Native_instance;
  var Platform_Browser_instance;
  var Platform_Node_instance;
  var Platform_entriesInitialized;
  function Platform_initEntries() {
    if (Platform_entriesInitialized)
      return Unit_instance;
    Platform_entriesInitialized = true;
    Platform_Jvm_instance = new Platform('Jvm', 0);
    Platform_Native_instance = new Platform('Native', 1);
    Platform_Browser_instance = new Platform('Browser', 2);
    Platform_Node_instance = new Platform('Node', 3);
  }
  function Platform(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PlatformUtils() {
    PlatformUtils_instance = this;
    this.e38_1 = get_platform(this).equals(Platform_Browser_getInstance());
    this.f38_1 = get_platform(this).equals(Platform_Node_getInstance());
    this.g38_1 = get_platform(this).equals(Platform_Jvm_getInstance());
    this.h38_1 = get_platform(this).equals(Platform_Native_getInstance());
    this.i38_1 = get_isDevelopmentMode(this);
    this.j38_1 = get_isNewMemoryModel(this);
  }
  var PlatformUtils_instance;
  function PlatformUtils_getInstance() {
    if (PlatformUtils_instance == null)
      new PlatformUtils();
    return PlatformUtils_instance;
  }
  function Platform_Jvm_getInstance() {
    Platform_initEntries();
    return Platform_Jvm_instance;
  }
  function Platform_Native_getInstance() {
    Platform_initEntries();
    return Platform_Native_instance;
  }
  function Platform_Browser_getInstance() {
    Platform_initEntries();
    return Platform_Browser_instance;
  }
  function Platform_Node_getInstance() {
    Platform_initEntries();
    return Platform_Node_instance;
  }
  function StringValues() {
  }
  function ensureListForKey($this, name) {
    var tmp0_elvis_lhs = $this.q38_1.y1(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.collections.mutableListOf' call
      var this_0 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.ktor.util.StringValuesBuilderImpl.ensureListForKey.<anonymous>' call
      $this.r38(name);
      // Inline function 'kotlin.collections.set' call
      $this.q38_1.b2(name, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function StringValuesBuilderImpl$appendAll$lambda(this$0) {
    return function (name, values) {
      this$0.s38(name, values);
      return Unit_instance;
    };
  }
  function StringValuesBuilderImpl(caseInsensitiveName, size) {
    caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
    size = size === VOID ? 8 : size;
    this.p38_1 = caseInsensitiveName;
    this.q38_1 = this.p38_1 ? caseInsensitiveMap() : LinkedHashMap_init_$Create$_0(size);
  }
  protoOf(StringValuesBuilderImpl).k38 = function () {
    return this.p38_1;
  };
  protoOf(StringValuesBuilderImpl).l38 = function (name) {
    return this.q38_1.y1(name);
  };
  protoOf(StringValuesBuilderImpl).t38 = function (name) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.q38_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w1(name);
  };
  protoOf(StringValuesBuilderImpl).u38 = function (name, value) {
    var tmp0_safe_receiver = this.q38_1.y1(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r(value);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(StringValuesBuilderImpl).m38 = function () {
    return this.q38_1.z1();
  };
  protoOf(StringValuesBuilderImpl).o = function () {
    return this.q38_1.o();
  };
  protoOf(StringValuesBuilderImpl).n38 = function () {
    return unmodifiable(this.q38_1.t());
  };
  protoOf(StringValuesBuilderImpl).v38 = function (name, value) {
    this.w38(value);
    var list = ensureListForKey(this, name);
    list.s1();
    list.e(value);
  };
  protoOf(StringValuesBuilderImpl).w2i = function (name) {
    var tmp0_safe_receiver = this.l38(name);
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  };
  protoOf(StringValuesBuilderImpl).x38 = function (name, value) {
    this.w38(value);
    ensureListForKey(this, name).e(value);
  };
  protoOf(StringValuesBuilderImpl).y38 = function (stringValues) {
    stringValues.o38(StringValuesBuilderImpl$appendAll$lambda(this));
  };
  protoOf(StringValuesBuilderImpl).s38 = function (name, values) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var list = ensureListForKey(this, name);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = values.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.util.StringValuesBuilderImpl.appendAll.<anonymous>.<anonymous>' call
      this.w38(element);
      list.e(element);
    }
  };
  protoOf(StringValuesBuilderImpl).z38 = function (name) {
    this.q38_1.c2(name);
  };
  protoOf(StringValuesBuilderImpl).s1 = function () {
    this.q38_1.s1();
  };
  protoOf(StringValuesBuilderImpl).r38 = function (name) {
  };
  protoOf(StringValuesBuilderImpl).w38 = function (value) {
  };
  function listForKey($this, name) {
    return $this.b39_1.y1(name);
  }
  function StringValuesImpl(caseInsensitiveName, values) {
    caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
    values = values === VOID ? emptyMap() : values;
    this.a39_1 = caseInsensitiveName;
    var tmp;
    if (this.a39_1) {
      tmp = caseInsensitiveMap();
    } else {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap_init_$Create$();
    }
    var newMap = tmp;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = values.t().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.util.StringValuesImpl.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.u();
      // Inline function 'kotlin.collections.component2' call
      var value = element.v();
      // Inline function 'kotlin.collections.set' call
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = value.j();
      var list = ArrayList_init_$Create$(size);
      // Inline function 'kotlin.repeat' call
      // Inline function 'kotlin.contracts.contract' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.MutableList.<anonymous>' call
          // Inline function 'io.ktor.util.StringValuesImpl.<anonymous>.<anonymous>' call
          var tmp$ret$4 = value.p(index);
          list.e(tmp$ret$4);
        }
         while (inductionVariable < size);
      newMap.b2(key, list);
    }
    this.b39_1 = newMap;
  }
  protoOf(StringValuesImpl).k38 = function () {
    return this.a39_1;
  };
  protoOf(StringValuesImpl).w2i = function (name) {
    var tmp0_safe_receiver = listForKey(this, name);
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  };
  protoOf(StringValuesImpl).l38 = function (name) {
    return listForKey(this, name);
  };
  protoOf(StringValuesImpl).m38 = function () {
    return unmodifiable(this.b39_1.z1());
  };
  protoOf(StringValuesImpl).o = function () {
    return this.b39_1.o();
  };
  protoOf(StringValuesImpl).n38 = function () {
    return unmodifiable(this.b39_1.t());
  };
  protoOf(StringValuesImpl).o38 = function (body) {
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.b39_1.t().g();
    while (tmp0_iterator.h()) {
      var tmp1_loop_parameter = tmp0_iterator.i();
      // Inline function 'kotlin.collections.component1' call
      var key = tmp1_loop_parameter.u();
      // Inline function 'kotlin.collections.component2' call
      var value = tmp1_loop_parameter.v();
      body(key, value);
    }
  };
  protoOf(StringValuesImpl).toString = function () {
    return 'StringValues(case=' + !this.a39_1 + ') ' + toString_1(this.n38());
  };
  protoOf(StringValuesImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, StringValues) : false))
      return false;
    if (!(this.a39_1 === other.k38()))
      return false;
    return entriesEquals(this.n38(), other.n38());
  };
  protoOf(StringValuesImpl).hashCode = function () {
    return entriesHashCode(this.n38(), imul(31, getBooleanHashCode(this.a39_1)));
  };
  function appendAll(_this__u8e3s4, builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.util.appendAll.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = builder.n38().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.ktor.util.appendAll.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var name = element.u();
      // Inline function 'kotlin.collections.component2' call
      var values = element.v();
      _this__u8e3s4.s38(name, values);
    }
    return _this__u8e3s4;
  }
  function appendIfNameAbsent(_this__u8e3s4, name, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    $l$block: {
      // Inline function 'io.ktor.util.appendIfNameAbsent.<anonymous>' call
      if (_this__u8e3s4.t38(name)) {
        break $l$block;
      }
      _this__u8e3s4.x38(name, value);
    }
    return _this__u8e3s4;
  }
  function entriesEquals(a, b) {
    return equals(a, b);
  }
  function entriesHashCode(entries, seed) {
    return imul(seed, 31) + hashCode(entries) | 0;
  }
  function toLowerCasePreservingASCIIRules(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.indexOfFirst' call
      var inductionVariable = 0;
      var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'io.ktor.util.toLowerCasePreservingASCIIRules.<anonymous>' call
          var it = charSequenceGet(_this__u8e3s4, index);
          if (!(toLowerCasePreservingASCII(it) === it)) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    var firstIndex = tmp$ret$1;
    if (firstIndex === -1) {
      return _this__u8e3s4;
    }
    var original = _this__u8e3s4;
    // Inline function 'kotlin.text.buildString' call
    var capacity = _this__u8e3s4.length;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$(capacity);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.util.toLowerCasePreservingASCIIRules.<anonymous>' call
    this_0.ab(original, 0, firstIndex);
    var inductionVariable_0 = firstIndex;
    var last_0 = get_lastIndex(original);
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0.p7(toLowerCasePreservingASCII(charSequenceGet(original, index_0)));
      }
       while (!(index_0 === last_0));
    return this_0.toString();
  }
  function toLowerCasePreservingASCII(ch) {
    var tmp;
    if (_Char___init__impl__6a9atx(65) <= ch ? ch <= _Char___init__impl__6a9atx(90) : false) {
      tmp = Char__plus_impl_qi7pgj(ch, 32);
    } else if (_Char___init__impl__6a9atx(0) <= ch ? ch <= _Char___init__impl__6a9atx(127) : false) {
      tmp = ch;
    } else {
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = toString_0(ch).toLowerCase();
      tmp = charSequenceGet(tmp$ret$2, 0);
    }
    return tmp;
  }
  function CaseInsensitiveString(content) {
    this.k37_1 = content;
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.k37_1.toLowerCase();
    tmp.l37_1 = getStringHashCode(tmp$ret$1);
  }
  protoOf(CaseInsensitiveString).equals = function (other) {
    var tmp0_safe_receiver = other instanceof CaseInsensitiveString ? other : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k37_1;
    return (tmp1_safe_receiver == null ? null : equals_0(tmp1_safe_receiver, this.k37_1, true)) === true;
  };
  protoOf(CaseInsensitiveString).hashCode = function () {
    return this.l37_1;
  };
  protoOf(CaseInsensitiveString).toString = function () {
    return this.k37_1;
  };
  function caseInsensitive(_this__u8e3s4) {
    return new CaseInsensitiveString(_this__u8e3s4);
  }
  function CopyOnWriteHashMap() {
    this.c39_1 = atomic$ref$1(emptyMap());
  }
  protoOf(CopyOnWriteHashMap).d39 = function (key) {
    return this.c39_1.kotlinx$atomicfu$value.y1(key);
  };
  function Companion() {
    Companion_instance_0 = this;
    this.e39_1 = GMTDate_0(new Long(0, 0));
  }
  var Companion_instance_0;
  function Companion_getInstance() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function GMTDate(seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp) {
    Companion_getInstance();
    this.f39_1 = seconds;
    this.g39_1 = minutes;
    this.h39_1 = hours;
    this.i39_1 = dayOfWeek;
    this.j39_1 = dayOfMonth;
    this.k39_1 = dayOfYear;
    this.l39_1 = month;
    this.m39_1 = year;
    this.n39_1 = timestamp;
  }
  protoOf(GMTDate).o39 = function (other) {
    return this.n39_1.a1(other.n39_1);
  };
  protoOf(GMTDate).d = function (other) {
    return this.o39(other instanceof GMTDate ? other : THROW_CCE());
  };
  protoOf(GMTDate).toString = function () {
    return 'GMTDate(seconds=' + this.f39_1 + ', minutes=' + this.g39_1 + ', hours=' + this.h39_1 + ', dayOfWeek=' + this.i39_1.toString() + ', dayOfMonth=' + this.j39_1 + ', dayOfYear=' + this.k39_1 + ', month=' + this.l39_1.toString() + ', year=' + this.m39_1 + ', timestamp=' + this.n39_1.toString() + ')';
  };
  protoOf(GMTDate).hashCode = function () {
    var result = this.f39_1;
    result = imul(result, 31) + this.g39_1 | 0;
    result = imul(result, 31) + this.h39_1 | 0;
    result = imul(result, 31) + this.i39_1.hashCode() | 0;
    result = imul(result, 31) + this.j39_1 | 0;
    result = imul(result, 31) + this.k39_1 | 0;
    result = imul(result, 31) + this.l39_1.hashCode() | 0;
    result = imul(result, 31) + this.m39_1 | 0;
    result = imul(result, 31) + this.n39_1.hashCode() | 0;
    return result;
  };
  protoOf(GMTDate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GMTDate))
      return false;
    var tmp0_other_with_cast = other instanceof GMTDate ? other : THROW_CCE();
    if (!(this.f39_1 === tmp0_other_with_cast.f39_1))
      return false;
    if (!(this.g39_1 === tmp0_other_with_cast.g39_1))
      return false;
    if (!(this.h39_1 === tmp0_other_with_cast.h39_1))
      return false;
    if (!this.i39_1.equals(tmp0_other_with_cast.i39_1))
      return false;
    if (!(this.j39_1 === tmp0_other_with_cast.j39_1))
      return false;
    if (!(this.k39_1 === tmp0_other_with_cast.k39_1))
      return false;
    if (!this.l39_1.equals(tmp0_other_with_cast.l39_1))
      return false;
    if (!(this.m39_1 === tmp0_other_with_cast.m39_1))
      return false;
    if (!this.n39_1.equals(tmp0_other_with_cast.n39_1))
      return false;
    return true;
  };
  var WeekDay_MONDAY_instance;
  var WeekDay_TUESDAY_instance;
  var WeekDay_WEDNESDAY_instance;
  var WeekDay_THURSDAY_instance;
  var WeekDay_FRIDAY_instance;
  var WeekDay_SATURDAY_instance;
  var WeekDay_SUNDAY_instance;
  function Companion_0() {
  }
  protoOf(Companion_0).p39 = function (ordinal) {
    return values()[ordinal];
  };
  var Companion_instance_1;
  function Companion_getInstance_0() {
    return Companion_instance_1;
  }
  function values() {
    return [WeekDay_MONDAY_getInstance(), WeekDay_TUESDAY_getInstance(), WeekDay_WEDNESDAY_getInstance(), WeekDay_THURSDAY_getInstance(), WeekDay_FRIDAY_getInstance(), WeekDay_SATURDAY_getInstance(), WeekDay_SUNDAY_getInstance()];
  }
  var WeekDay_entriesInitialized;
  function WeekDay_initEntries() {
    if (WeekDay_entriesInitialized)
      return Unit_instance;
    WeekDay_entriesInitialized = true;
    WeekDay_MONDAY_instance = new WeekDay('MONDAY', 0, 'Mon');
    WeekDay_TUESDAY_instance = new WeekDay('TUESDAY', 1, 'Tue');
    WeekDay_WEDNESDAY_instance = new WeekDay('WEDNESDAY', 2, 'Wed');
    WeekDay_THURSDAY_instance = new WeekDay('THURSDAY', 3, 'Thu');
    WeekDay_FRIDAY_instance = new WeekDay('FRIDAY', 4, 'Fri');
    WeekDay_SATURDAY_instance = new WeekDay('SATURDAY', 5, 'Sat');
    WeekDay_SUNDAY_instance = new WeekDay('SUNDAY', 6, 'Sun');
  }
  function WeekDay(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.s39_1 = value;
  }
  var Month_JANUARY_instance;
  var Month_FEBRUARY_instance;
  var Month_MARCH_instance;
  var Month_APRIL_instance;
  var Month_MAY_instance;
  var Month_JUNE_instance;
  var Month_JULY_instance;
  var Month_AUGUST_instance;
  var Month_SEPTEMBER_instance;
  var Month_OCTOBER_instance;
  var Month_NOVEMBER_instance;
  var Month_DECEMBER_instance;
  function Companion_1() {
  }
  protoOf(Companion_1).p39 = function (ordinal) {
    return values_0()[ordinal];
  };
  var Companion_instance_2;
  function Companion_getInstance_1() {
    return Companion_instance_2;
  }
  function values_0() {
    return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
  }
  var Month_entriesInitialized;
  function Month_initEntries() {
    if (Month_entriesInitialized)
      return Unit_instance;
    Month_entriesInitialized = true;
    Month_JANUARY_instance = new Month('JANUARY', 0, 'Jan');
    Month_FEBRUARY_instance = new Month('FEBRUARY', 1, 'Feb');
    Month_MARCH_instance = new Month('MARCH', 2, 'Mar');
    Month_APRIL_instance = new Month('APRIL', 3, 'Apr');
    Month_MAY_instance = new Month('MAY', 4, 'May');
    Month_JUNE_instance = new Month('JUNE', 5, 'Jun');
    Month_JULY_instance = new Month('JULY', 6, 'Jul');
    Month_AUGUST_instance = new Month('AUGUST', 7, 'Aug');
    Month_SEPTEMBER_instance = new Month('SEPTEMBER', 8, 'Sep');
    Month_OCTOBER_instance = new Month('OCTOBER', 9, 'Oct');
    Month_NOVEMBER_instance = new Month('NOVEMBER', 10, 'Nov');
    Month_DECEMBER_instance = new Month('DECEMBER', 11, 'Dec');
  }
  function Month(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.v39_1 = value;
  }
  function WeekDay_MONDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_MONDAY_instance;
  }
  function WeekDay_TUESDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_TUESDAY_instance;
  }
  function WeekDay_WEDNESDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_WEDNESDAY_instance;
  }
  function WeekDay_THURSDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_THURSDAY_instance;
  }
  function WeekDay_FRIDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_FRIDAY_instance;
  }
  function WeekDay_SATURDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_SATURDAY_instance;
  }
  function WeekDay_SUNDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_SUNDAY_instance;
  }
  function Month_JANUARY_getInstance() {
    Month_initEntries();
    return Month_JANUARY_instance;
  }
  function Month_FEBRUARY_getInstance() {
    Month_initEntries();
    return Month_FEBRUARY_instance;
  }
  function Month_MARCH_getInstance() {
    Month_initEntries();
    return Month_MARCH_instance;
  }
  function Month_APRIL_getInstance() {
    Month_initEntries();
    return Month_APRIL_instance;
  }
  function Month_MAY_getInstance() {
    Month_initEntries();
    return Month_MAY_instance;
  }
  function Month_JUNE_getInstance() {
    Month_initEntries();
    return Month_JUNE_instance;
  }
  function Month_JULY_getInstance() {
    Month_initEntries();
    return Month_JULY_instance;
  }
  function Month_AUGUST_getInstance() {
    Month_initEntries();
    return Month_AUGUST_instance;
  }
  function Month_SEPTEMBER_getInstance() {
    Month_initEntries();
    return Month_SEPTEMBER_instance;
  }
  function Month_OCTOBER_getInstance() {
    Month_initEntries();
    return Month_OCTOBER_instance;
  }
  function Month_NOVEMBER_getInstance() {
    Month_initEntries();
    return Month_NOVEMBER_instance;
  }
  function Month_DECEMBER_getInstance() {
    Month_initEntries();
    return Month_DECEMBER_instance;
  }
  var CONDITION_FALSE;
  var ALREADY_REMOVED;
  var LIST_EMPTY;
  var REMOVE_PREPARED;
  var NO_DECISION;
  function Symbol(symbol) {
    this.w39_1 = symbol;
  }
  protoOf(Symbol).toString = function () {
    return this.w39_1;
  };
  function LockFreeLinkedListNode() {
  }
  protoOf(LockFreeLinkedListNode).jx = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.x39_1;
    while (true) {
      // Inline function 'io.ktor.util.internal.LockFreeLinkedListNode.<get-next>.<anonymous>' call
      var next = this_0.kotlinx$atomicfu$value;
      if (!(next instanceof OpDescriptor))
        return next;
      next.fu(this);
    }
  };
  protoOf(LockFreeLinkedListNode).y39 = function () {
    return unwrap(this.jx());
  };
  function Removed() {
  }
  function OpDescriptor() {
  }
  function unwrap(_this__u8e3s4) {
    _init_properties_LockFreeLinkedList_kt__wekxce();
    var tmp0_safe_receiver = _this__u8e3s4 instanceof Removed ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z39_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      tmp = _this__u8e3s4 instanceof LockFreeLinkedListNode ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  var properties_initialized_LockFreeLinkedList_kt_lnmdgw;
  function _init_properties_LockFreeLinkedList_kt__wekxce() {
    if (!properties_initialized_LockFreeLinkedList_kt_lnmdgw) {
      properties_initialized_LockFreeLinkedList_kt_lnmdgw = true;
      CONDITION_FALSE = new Symbol('CONDITION_FALSE');
      ALREADY_REMOVED = new Symbol('ALREADY_REMOVED');
      LIST_EMPTY = new Symbol('LIST_EMPTY');
      REMOVE_PREPARED = new Symbol('REMOVE_PREPARED');
      NO_DECISION = new Symbol('NO_DECISION');
    }
  }
  function proceedLoop($this, $completion) {
    var tmp = new $proceedLoopCOROUTINE$1($this, $completion);
    tmp.l8_1 = Unit_instance;
    tmp.m8_1 = null;
    return tmp.r8();
  }
  function $proceedLoopCOROUTINE$1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i3a_1 = _this__u8e3s4;
  }
  protoOf($proceedLoopCOROUTINE$1).r8 = function () {
    var suspendResult = this.l8_1;
    $sm: do
      try {
        var tmp = this.j8_1;
        switch (tmp) {
          case 0:
            this.k8_1 = 6;
            this.j8_1 = 1;
            continue $sm;
          case 1:
            this.j3a_1 = this.i3a_1.q3a_1;
            if (this.j3a_1 === -1) {
              this.j8_1 = 5;
              continue $sm;
            } else {
              this.j8_1 = 2;
              continue $sm;
            }

          case 2:
            this.k3a_1 = this.i3a_1.n3a_1;
            if (this.j3a_1 >= this.k3a_1.j()) {
              this.i3a_1.r3a();
              this.j8_1 = 5;
              continue $sm;
            } else {
              this.j8_1 = 3;
              continue $sm;
            }

          case 3:
            this.l3a_1 = this.k3a_1.p(this.j3a_1);
            this.i3a_1.q3a_1 = this.j3a_1 + 1 | 0;
            this.j8_1 = 4;
            var tmp_0 = this.l3a_1;
            suspendResult = (isSuspendFunction(tmp_0, 2) ? tmp_0 : THROW_CCE())(this.i3a_1, this.i3a_1.p3a_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.j8_1 = 1;
            continue $sm;
          case 5:
            return this.i3a_1.p3a_1;
          case 6:
            throw this.m8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.k8_1 === 6) {
          throw e;
        } else {
          this.j8_1 = this.k8_1;
          this.m8_1 = e;
        }
      }
     while (true);
  };
  function DebugPipelineContext(context, interceptors, subject, coroutineContext) {
    PipelineContext.call(this, context);
    this.n3a_1 = interceptors;
    this.o3a_1 = coroutineContext;
    this.p3a_1 = subject;
    this.q3a_1 = 0;
  }
  protoOf(DebugPipelineContext).pj = function () {
    return this.o3a_1;
  };
  protoOf(DebugPipelineContext).s3a = function () {
    return this.p3a_1;
  };
  protoOf(DebugPipelineContext).r3a = function () {
    this.q3a_1 = -1;
  };
  protoOf(DebugPipelineContext).t3a = function (subject, $completion) {
    this.p3a_1 = subject;
    return this.u3a($completion);
  };
  protoOf(DebugPipelineContext).u3a = function ($completion) {
    var index = this.q3a_1;
    if (index < 0)
      return this.p3a_1;
    if (index >= this.n3a_1.j()) {
      this.r3a();
      return this.p3a_1;
    }
    return proceedLoop(this, $completion);
  };
  protoOf(DebugPipelineContext).v3a = function (initial, $completion) {
    this.q3a_1 = 0;
    this.p3a_1 = initial;
    return this.u3a($completion);
  };
  function PhaseContent_init_$Init$(phase, relation, $this) {
    var tmp = Companion_getInstance_2().w3a_1;
    PhaseContent.call($this, phase, relation, isInterface(tmp, KtMutableList) ? tmp : THROW_CCE());
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!Companion_getInstance_2().w3a_1.o()) {
      // Inline function 'io.ktor.util.pipeline.PhaseContent.<init>.<anonymous>' call
      var message = 'The shared empty array list has been modified';
      throw IllegalStateException_init_$Create$(toString_1(message));
    }
    return $this;
  }
  function PhaseContent_init_$Create$(phase, relation) {
    return PhaseContent_init_$Init$(phase, relation, objectCreate(protoOf(PhaseContent)));
  }
  function copyInterceptors($this) {
    $this.z3a_1 = $this.b3b();
    $this.a3b_1 = false;
  }
  function Companion_2() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.w3a_1 = ArrayList_init_$Create$_0();
  }
  var Companion_instance_3;
  function Companion_getInstance_2() {
    if (Companion_instance_3 == null)
      new Companion_2();
    return Companion_instance_3;
  }
  function PhaseContent(phase, relation, interceptors) {
    Companion_getInstance_2();
    this.x3a_1 = phase;
    this.y3a_1 = relation;
    this.z3a_1 = interceptors;
    this.a3b_1 = true;
  }
  protoOf(PhaseContent).n2o = function () {
    return this.z3a_1.o();
  };
  protoOf(PhaseContent).j = function () {
    return this.z3a_1.j();
  };
  protoOf(PhaseContent).c3b = function (interceptor) {
    if (this.a3b_1) {
      copyInterceptors(this);
    }
    this.z3a_1.e(interceptor);
  };
  protoOf(PhaseContent).d3b = function (destination) {
    var interceptors = this.z3a_1;
    if (destination instanceof ArrayList) {
      destination.z4(destination.j() + interceptors.j() | 0);
    }
    var inductionVariable = 0;
    var last = interceptors.j();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        destination.e(interceptors.p(index));
      }
       while (inductionVariable < last);
  };
  protoOf(PhaseContent).e3b = function () {
    this.a3b_1 = true;
    return this.z3a_1;
  };
  protoOf(PhaseContent).b3b = function () {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.mutableListOf' call
    var this_0 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.util.pipeline.PhaseContent.copiedInterceptors.<anonymous>' call
    this_0.n(this.z3a_1);
    return this_0;
  };
  protoOf(PhaseContent).toString = function () {
    return 'Phase `' + this.x3a_1.f3b_1 + '`, ' + this.j() + ' handlers';
  };
  function _set_interceptors__wod97b($this, value) {
    $this.k3b_1.kotlinx$atomicfu$value = value;
  }
  function _get_interceptors__h4min7($this) {
    return $this.k3b_1.kotlinx$atomicfu$value;
  }
  function createContext($this, context, subject, coroutineContext) {
    return pipelineContextFor(context, sharedInterceptorsList($this), subject, coroutineContext, $this.n3b());
  }
  function findPhase($this, phase) {
    var phasesList = $this.i3b_1;
    var inductionVariable = 0;
    var last = phasesList.j();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.p(index);
        if (current === phase) {
          var content = PhaseContent_init_$Create$(phase, Last_getInstance());
          phasesList.t1(index, content);
          return content;
        }
        var tmp;
        if (current instanceof PhaseContent) {
          tmp = current.x3a_1 === phase;
        } else {
          tmp = false;
        }
        if (tmp) {
          return current instanceof PhaseContent ? current : THROW_CCE();
        }
      }
       while (inductionVariable < last);
    return null;
  }
  function findPhaseIndex($this, phase) {
    var phasesList = $this.i3b_1;
    var inductionVariable = 0;
    var last = phasesList.j();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.p(index);
        var tmp;
        if (current === phase) {
          tmp = true;
        } else {
          var tmp_0;
          if (current instanceof PhaseContent) {
            tmp_0 = current.x3a_1 === phase;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        if (tmp) {
          return index;
        }
      }
       while (inductionVariable < last);
    return -1;
  }
  function hasPhase($this, phase) {
    var phasesList = $this.i3b_1;
    var inductionVariable = 0;
    var last = phasesList.j();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.p(index);
        var tmp;
        if (current === phase) {
          tmp = true;
        } else {
          var tmp_0;
          if (current instanceof PhaseContent) {
            tmp_0 = current.x3a_1 === phase;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        if (tmp) {
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  function cacheInterceptors($this) {
    var interceptorsQuantity = $this.j3b_1;
    if (interceptorsQuantity === 0) {
      notSharedInterceptorsList($this, emptyList());
      return emptyList();
    }
    var phases = $this.i3b_1;
    if (interceptorsQuantity === 1) {
      var inductionVariable = 0;
      var last = get_lastIndex_0(phases);
      if (inductionVariable <= last)
        $l$loop_0: do {
          var phaseIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp = phases.p(phaseIndex);
          var tmp1_elvis_lhs = tmp instanceof PhaseContent ? tmp : null;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var phaseContent = tmp_0;
          if (phaseContent.n2o())
            continue $l$loop_0;
          var interceptors = phaseContent.e3b();
          setInterceptorsListFromPhase($this, phaseContent);
          return interceptors;
        }
         while (!(phaseIndex === last));
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable_0 = 0;
    var last_0 = get_lastIndex_0(phases);
    if (inductionVariable_0 <= last_0)
      $l$loop_1: do {
        var phaseIndex_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp_1 = phases.p(phaseIndex_0);
        var tmp3_elvis_lhs = tmp_1 instanceof PhaseContent ? tmp_1 : null;
        var tmp_2;
        if (tmp3_elvis_lhs == null) {
          continue $l$loop_1;
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var phase = tmp_2;
        phase.d3b(destination);
      }
       while (!(phaseIndex_0 === last_0));
    notSharedInterceptorsList($this, destination);
    return destination;
  }
  function sharedInterceptorsList($this) {
    if (_get_interceptors__h4min7($this) == null) {
      cacheInterceptors($this);
    }
    $this.l3b_1 = true;
    return ensureNotNull(_get_interceptors__h4min7($this));
  }
  function resetInterceptorsList($this) {
    _set_interceptors__wod97b($this, null);
    $this.l3b_1 = false;
    $this.m3b_1 = null;
  }
  function notSharedInterceptorsList($this, list) {
    _set_interceptors__wod97b($this, list);
    $this.l3b_1 = false;
    $this.m3b_1 = null;
  }
  function setInterceptorsListFromPhase($this, phaseContent) {
    _set_interceptors__wod97b($this, phaseContent.e3b());
    $this.l3b_1 = false;
    $this.m3b_1 = phaseContent.x3a_1;
  }
  function tryAddToPhaseFastPath($this, phase, block) {
    var currentInterceptors = _get_interceptors__h4min7($this);
    if ($this.i3b_1.o() || currentInterceptors == null) {
      return false;
    }
    var tmp;
    if ($this.l3b_1) {
      tmp = true;
    } else {
      tmp = !(!(currentInterceptors == null) ? isInterface(currentInterceptors, KtMutableList) : false);
    }
    if (tmp) {
      return false;
    }
    if (equals($this.m3b_1, phase)) {
      currentInterceptors.e(block);
      return true;
    }
    if (equals(phase, last($this.i3b_1)) || findPhaseIndex($this, phase) === get_lastIndex_0($this.i3b_1)) {
      ensureNotNull(findPhase($this, phase)).c3b(block);
      currentInterceptors.e(block);
      return true;
    }
    return false;
  }
  function Pipeline(phases) {
    this.g3b_1 = AttributesJsFn(true);
    this.h3b_1 = false;
    this.i3b_1 = mutableListOf(phases.slice());
    this.j3b_1 = 0;
    this.k3b_1 = atomic$ref$1(null);
    this.l3b_1 = false;
    this.m3b_1 = null;
  }
  protoOf(Pipeline).n3b = function () {
    return this.h3b_1;
  };
  protoOf(Pipeline).o3b = function (context, subject, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.p8();
    return createContext(this, context, subject, tmp$ret$0).v3a(subject, $completion);
  };
  protoOf(Pipeline).q3b = function (reference, phase) {
    if (hasPhase(this, phase))
      return Unit_instance;
    var index = findPhaseIndex(this, reference);
    if (index === -1) {
      throw new InvalidPhaseException('Phase ' + reference.toString() + ' was not registered for this pipeline');
    }
    var lastRelatedPhaseIndex = index;
    var inductionVariable = index + 1 | 0;
    var last = get_lastIndex_0(this.i3b_1);
    if (inductionVariable <= last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.i3b_1.p(i);
        var tmp1_safe_receiver = tmp instanceof PhaseContent ? tmp : null;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.y3a_1;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var relation = tmp_0;
        var tmp3_safe_receiver = relation instanceof After ? relation : null;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.r3b_1;
        var tmp_1;
        if (tmp4_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_1 = tmp4_elvis_lhs;
        }
        var relatedTo = tmp_1;
        lastRelatedPhaseIndex = equals(relatedTo, reference) ? i : lastRelatedPhaseIndex;
      }
       while (!(i === last));
    this.i3b_1.u1(lastRelatedPhaseIndex + 1 | 0, PhaseContent_init_$Create$(phase, new After(reference)));
  };
  protoOf(Pipeline).s3b = function (reference, phase) {
    if (hasPhase(this, phase))
      return Unit_instance;
    var index = findPhaseIndex(this, reference);
    if (index === -1) {
      throw new InvalidPhaseException('Phase ' + reference.toString() + ' was not registered for this pipeline');
    }
    this.i3b_1.u1(index, PhaseContent_init_$Create$(phase, new Before(reference)));
  };
  protoOf(Pipeline).t3b = function (phase, block) {
    var tmp0_elvis_lhs = findPhase(this, phase);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw new InvalidPhaseException('Phase ' + phase.toString() + ' was not registered for this pipeline');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var phaseContent = tmp;
    if (typeof block !== 'function')
      THROW_CCE();
    if (tryAddToPhaseFastPath(this, phase, block)) {
      this.j3b_1 = this.j3b_1 + 1 | 0;
      return Unit_instance;
    }
    phaseContent.c3b(block);
    this.j3b_1 = this.j3b_1 + 1 | 0;
    resetInterceptorsList(this);
    this.u3b();
  };
  protoOf(Pipeline).u3b = function () {
  };
  function PipelineContext(context) {
    this.p3b_1 = context;
  }
  function pipelineContextFor(context, interceptors, subject, coroutineContext, debugMode) {
    debugMode = debugMode === VOID ? false : debugMode;
    var tmp;
    if (get_DISABLE_SFG() || debugMode) {
      tmp = new DebugPipelineContext(context, interceptors, subject, coroutineContext);
    } else {
      tmp = new SuspendFunctionGun(subject, context, interceptors);
    }
    return tmp;
  }
  function PipelinePhase(name) {
    this.f3b_1 = name;
  }
  protoOf(PipelinePhase).toString = function () {
    return "Phase('" + this.f3b_1 + "')";
  };
  function InvalidPhaseException(message) {
    extendThrowable(this, message);
    captureStack(this, InvalidPhaseException);
  }
  function After(relativeTo) {
    PipelinePhaseRelation.call(this);
    this.r3b_1 = relativeTo;
  }
  function Before(relativeTo) {
    PipelinePhaseRelation.call(this);
    this.v3b_1 = relativeTo;
  }
  function Last() {
    Last_instance = this;
    PipelinePhaseRelation.call(this);
  }
  var Last_instance;
  function Last_getInstance() {
    if (Last_instance == null)
      new Last();
    return Last_instance;
  }
  function PipelinePhaseRelation() {
  }
  function recoverStackTraceBridge(exception, continuation) {
    var tmp;
    try {
      tmp = withCause(recoverStackTrace(exception, continuation), exception.cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var _ = $p;
        tmp_0 = exception;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function loop($this, direct) {
    do {
      var currentIndex = $this.c3c_1;
      if (currentIndex === $this.x3b_1.j()) {
        if (!direct) {
          // Inline function 'kotlin.Companion.success' call
          var value = $this.z3b_1;
          var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
          resumeRootWith($this, tmp$ret$0);
          return false;
        }
        return true;
      }
      $this.c3c_1 = currentIndex + 1 | 0;
      var next = $this.x3b_1.p(currentIndex);
      try {
        var result = next($this, $this.z3b_1, $this.y3b_1);
        if (result === get_COROUTINE_SUSPENDED())
          return false;
      } catch ($p) {
        if ($p instanceof Error) {
          var cause = $p;
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
          resumeRootWith($this, tmp$ret$1);
          return false;
        } else {
          throw $p;
        }
      }
    }
     while (true);
  }
  function resumeRootWith($this, result) {
    if ($this.b3c_1 < 0) {
      // Inline function 'kotlin.error' call
      var message = 'No more continuations to resume';
      throw IllegalStateException_init_$Create$(toString_1(message));
    }
    var next = ensureNotNull($this.a3c_1[$this.b3c_1]);
    var tmp1 = $this.b3c_1;
    $this.b3c_1 = tmp1 - 1 | 0;
    $this.a3c_1[tmp1] = null;
    if (!_Result___get_isFailure__impl__jpiriv(result)) {
      next.u8(result);
    } else {
      var exception = recoverStackTraceBridge(ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result)), next);
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      next.u8(tmp$ret$0);
    }
  }
  function discardLastRootContinuation($this) {
    if ($this.b3c_1 < 0)
      throw IllegalStateException_init_$Create$('No more continuations to resume');
    var tmp1 = $this.b3c_1;
    $this.b3c_1 = tmp1 - 1 | 0;
    $this.a3c_1[tmp1] = null;
  }
  function SuspendFunctionGun$continuation$1(this$0) {
    this.e3c_1 = this$0;
    this.d3c_1 = -2147483648;
  }
  protoOf(SuspendFunctionGun$continuation$1).p8 = function () {
    var continuation = this.e3c_1.a3c_1[this.e3c_1.b3c_1];
    if (!(continuation === this) && !(continuation == null))
      return continuation.p8();
    var index = this.e3c_1.b3c_1 - 1 | 0;
    while (index >= 0) {
      var tmp0 = index;
      index = tmp0 - 1 | 0;
      var cont = this.e3c_1.a3c_1[tmp0];
      if (!(cont === this) && !(cont == null))
        return cont.p8();
    }
    // Inline function 'kotlin.error' call
    var message = 'Not started';
    throw IllegalStateException_init_$Create$(toString_1(message));
  };
  protoOf(SuspendFunctionGun$continuation$1).f3c = function (result) {
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result));
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      resumeRootWith(this.e3c_1, tmp$ret$0);
      return Unit_instance;
    }
    loop(this.e3c_1, false);
  };
  protoOf(SuspendFunctionGun$continuation$1).u8 = function (result) {
    return this.f3c(result);
  };
  function SuspendFunctionGun(initial, context, blocks) {
    PipelineContext.call(this, context);
    this.x3b_1 = blocks;
    var tmp = this;
    tmp.y3b_1 = new SuspendFunctionGun$continuation$1(this);
    this.z3b_1 = initial;
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.x3b_1.j();
    tmp_0.a3c_1 = fillArrayVal(Array(size), null);
    this.b3c_1 = -1;
    this.c3c_1 = 0;
  }
  protoOf(SuspendFunctionGun).pj = function () {
    return this.y3b_1.p8();
  };
  protoOf(SuspendFunctionGun).s3a = function () {
    return this.z3b_1;
  };
  protoOf(SuspendFunctionGun).u3a = function ($completion) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'io.ktor.util.pipeline.SuspendFunctionGun.proceed.<anonymous>' call
      if (this.c3c_1 === this.x3b_1.j()) {
        tmp$ret$0 = this.z3b_1;
        break $l$block_0;
      }
      this.g3c(intercepted($completion));
      if (loop(this, true)) {
        discardLastRootContinuation(this);
        tmp$ret$0 = this.z3b_1;
        break $l$block_0;
      }
      tmp$ret$0 = get_COROUTINE_SUSPENDED();
    }
    return tmp$ret$0;
  };
  protoOf(SuspendFunctionGun).t3a = function (subject, $completion) {
    this.z3b_1 = subject;
    return this.u3a($completion);
  };
  protoOf(SuspendFunctionGun).v3a = function (initial, $completion) {
    this.c3c_1 = 0;
    if (this.c3c_1 === this.x3b_1.j())
      return initial;
    this.z3b_1 = initial;
    if (this.b3c_1 >= 0)
      throw IllegalStateException_init_$Create$('Already started');
    return this.u3a($completion);
  };
  protoOf(SuspendFunctionGun).g3c = function (continuation) {
    this.b3c_1 = this.b3c_1 + 1 | 0;
    this.a3c_1[this.b3c_1] = continuation;
  };
  function TypeInfo(type, reifiedType, kotlinType) {
    kotlinType = kotlinType === VOID ? null : kotlinType;
    this.h3c_1 = type;
    this.i3c_1 = reifiedType;
    this.j3c_1 = kotlinType;
  }
  protoOf(TypeInfo).toString = function () {
    return 'TypeInfo(type=' + toString_1(this.h3c_1) + ', reifiedType=' + toString_1(this.i3c_1) + ', kotlinType=' + toString(this.j3c_1) + ')';
  };
  protoOf(TypeInfo).hashCode = function () {
    var result = this.h3c_1.hashCode();
    result = imul(result, 31) + hashCode(this.i3c_1) | 0;
    result = imul(result, 31) + (this.j3c_1 == null ? 0 : hashCode(this.j3c_1)) | 0;
    return result;
  };
  protoOf(TypeInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TypeInfo ? other : THROW_CCE();
    if (!this.h3c_1.equals(tmp0_other_with_cast.h3c_1))
      return false;
    if (!equals(this.i3c_1, tmp0_other_with_cast.i3c_1))
      return false;
    if (!equals(this.j3c_1, tmp0_other_with_cast.j3c_1))
      return false;
    return true;
  };
  function AttributesJsFn(concurrent) {
    concurrent = concurrent === VOID ? false : concurrent;
    return new AttributesJs();
  }
  function AttributesJs() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.k3c_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(AttributesJs).q34 = function (key) {
    var tmp = this.k3c_1.y1(key);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(AttributesJs).r34 = function (key) {
    return this.k3c_1.w1(key);
  };
  protoOf(AttributesJs).s34 = function (key, value) {
    // Inline function 'kotlin.collections.set' call
    this.k3c_1.b2(key, value);
  };
  protoOf(AttributesJs).t34 = function (key) {
    this.k3c_1.c2(key);
  };
  protoOf(AttributesJs).u34 = function (key, block) {
    var tmp0_safe_receiver = this.k3c_1.y1(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
    }
    // Inline function 'kotlin.also' call
    var this_0 = block();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.util.AttributesJs.computeIfAbsent.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    this.k3c_1.b2(key, this_0);
    return this_0;
  };
  protoOf(AttributesJs).v34 = function () {
    return toList(this.k3c_1.z1());
  };
  function unmodifiable(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  function get_platform(_this__u8e3s4) {
    var tmp = typeof process !== 'undefined' && process.versions != null && process.versions.node != null || (typeof window !== 'undefined' && typeof window.process !== 'undefined' && window.process.versions != null && window.process.versions.node != null);
    var hasNodeApi = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
    return hasNodeApi ? Platform_Node_getInstance() : Platform_Browser_getInstance();
  }
  function get_isDevelopmentMode(_this__u8e3s4) {
    return false;
  }
  function get_isNewMemoryModel(_this__u8e3s4) {
    return true;
  }
  function GMTDate_0(timestamp) {
    timestamp = timestamp === VOID ? null : timestamp;
    var tmp1_safe_receiver = timestamp == null ? null : timestamp.d3();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.ktor.util.date.GMTDate.<anonymous>' call
      tmp = new Date(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var date = tmp2_elvis_lhs == null ? new Date() : tmp2_elvis_lhs;
    if (isNaN_0(date.getTime()))
      throw new InvalidTimestampException(ensureNotNull(timestamp));
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    var dayOfWeek = Companion_instance_1.p39((date.getUTCDay() + 6 | 0) % 7 | 0);
    var month = Companion_instance_2.p39(date.getUTCMonth());
    return new GMTDate(date.getUTCSeconds(), date.getUTCMinutes(), date.getUTCHours(), dayOfWeek, date.getUTCDate(), date.getUTCFullYear(), month, date.getUTCFullYear(), numberToLong(date.getTime()));
  }
  function InvalidTimestampException(timestamp) {
    IllegalStateException_init_$Init$('Invalid date timestamp exception: ' + timestamp.toString(), this);
    captureStack(this, InvalidTimestampException);
  }
  function KtorSimpleLogger(name) {
    return new KtorSimpleLogger$1();
  }
  function KtorSimpleLogger$1() {
    var tmp = this;
    var tmp_0;
    switch (PlatformUtils_getInstance().f38_1 || PlatformUtils_getInstance().e38_1) {
      case true:
        // Inline function 'kotlin.Result.getOrNull' call

        // Inline function 'kotlin.runCatching' call

        var tmp_1;
        try {
          // Inline function 'kotlin.Companion.success' call
          // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>' call
          var tmp_2 = process.env.KTOR_LOG_LEVEL;
          var value = (tmp_2 == null ? true : typeof tmp_2 === 'string') ? tmp_2 : THROW_CCE();
          tmp_1 = _Result___init__impl__xyqfz8(value);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp_1 = tmp_3;
        }

        var this_0 = tmp_1;
        var tmp_4;
        if (_Result___get_isFailure__impl__jpiriv(this_0)) {
          tmp_4 = null;
        } else {
          var tmp_5 = _Result___get_value__impl__bjfvqg(this_0);
          tmp_4 = (tmp_5 == null ? true : !(tmp_5 == null)) ? tmp_5 : THROW_CCE();
        }

        var tmp1_safe_receiver = tmp_4;
        var tmp_6;
        if (tmp1_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>' call
          var tmp$ret$6;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var indexedObject = values_1();
            var inductionVariable = 0;
            var last = indexedObject.length;
            while (inductionVariable < last) {
              var element = indexedObject[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>.<anonymous>' call
              if (element.e2_1 === tmp1_safe_receiver) {
                tmp$ret$6 = element;
                break $l$block;
              }
            }
            tmp$ret$6 = null;
          }
          tmp_6 = tmp$ret$6;
        }

        var tmp2_elvis_lhs = tmp_6;
        tmp_0 = tmp2_elvis_lhs == null ? LogLevel_INFO_getInstance() : tmp2_elvis_lhs;
        break;
      case false:
        tmp_0 = LogLevel_TRACE_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.l3c_1 = tmp_0;
  }
  protoOf(KtorSimpleLogger$1).m3c = function (message) {
    if (this.l3c_1.g2(LogLevel_TRACE_getInstance()) > 0)
      return Unit_instance;
    console.debug('TRACE: ' + message);
  };
  var LogLevel_TRACE_instance;
  var LogLevel_DEBUG_instance;
  var LogLevel_INFO_instance;
  var LogLevel_WARN_instance;
  var LogLevel_ERROR_instance;
  var LogLevel_NONE_instance;
  function values_1() {
    return [LogLevel_TRACE_getInstance(), LogLevel_DEBUG_getInstance(), LogLevel_INFO_getInstance(), LogLevel_WARN_getInstance(), LogLevel_ERROR_getInstance(), LogLevel_NONE_getInstance()];
  }
  var LogLevel_entriesInitialized;
  function LogLevel_initEntries() {
    if (LogLevel_entriesInitialized)
      return Unit_instance;
    LogLevel_entriesInitialized = true;
    LogLevel_TRACE_instance = new LogLevel('TRACE', 0);
    LogLevel_DEBUG_instance = new LogLevel('DEBUG', 1);
    LogLevel_INFO_instance = new LogLevel('INFO', 2);
    LogLevel_WARN_instance = new LogLevel('WARN', 3);
    LogLevel_ERROR_instance = new LogLevel('ERROR', 4);
    LogLevel_NONE_instance = new LogLevel('NONE', 5);
  }
  function LogLevel(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LogLevel_TRACE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_TRACE_instance;
  }
  function LogLevel_DEBUG_getInstance() {
    LogLevel_initEntries();
    return LogLevel_DEBUG_instance;
  }
  function LogLevel_INFO_getInstance() {
    LogLevel_initEntries();
    return LogLevel_INFO_instance;
  }
  function LogLevel_WARN_getInstance() {
    LogLevel_initEntries();
    return LogLevel_WARN_instance;
  }
  function LogLevel_ERROR_getInstance() {
    LogLevel_initEntries();
    return LogLevel_ERROR_instance;
  }
  function LogLevel_NONE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_NONE_instance;
  }
  function get_DISABLE_SFG() {
    return DISABLE_SFG;
  }
  var DISABLE_SFG;
  function withCause(_this__u8e3s4, cause) {
    return _this__u8e3s4;
  }
  function instanceOf(_this__u8e3s4, type) {
    return type.q9(_this__u8e3s4);
  }
  function typeInfoImpl(reifiedType, kClass, kType) {
    return new TypeInfo(kClass, reifiedType, kType);
  }
  function JsType() {
  }
  var JsType_instance;
  function JsType_getInstance() {
    return JsType_instance;
  }
  //region block: post-declaration
  protoOf(AttributesJs).p34 = get;
  //endregion
  //region block: init
  Companion_instance_1 = new Companion_0();
  Companion_instance_2 = new Companion_1();
  DISABLE_SFG = false;
  JsType_instance = new JsType();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = toByteArray;
  _.$_$.b = JsType_instance;
  _.$_$.c = PlatformUtils_getInstance;
  _.$_$.d = CopyOnWriteHashMap;
  _.$_$.e = GMTDate_0;
  _.$_$.f = LockFreeLinkedListNode;
  _.$_$.g = KtorSimpleLogger;
  _.$_$.h = PipelineContext;
  _.$_$.i = PipelinePhase;
  _.$_$.j = Pipeline;
  _.$_$.k = instanceOf;
  _.$_$.l = typeInfoImpl;
  _.$_$.m = AttributeKey;
  _.$_$.n = AttributesJsFn;
  _.$_$.o = SilentSupervisor;
  _.$_$.p = forEach;
  _.$_$.q = get_0;
  _.$_$.r = StringValuesBuilderImpl;
  _.$_$.s = StringValuesImpl;
  _.$_$.t = StringValues;
  _.$_$.u = appendAll;
  _.$_$.v = appendIfNameAbsent;
  _.$_$.w = copyToBoth;
  _.$_$.x = isLowerCase;
  _.$_$.y = get_platform;
  _.$_$.z = putAll;
  _.$_$.a1 = split;
  _.$_$.b1 = toCharArray;
  _.$_$.c1 = toLowerCasePreservingASCIIRules;
  //endregion
  return _;
}));
